import { useLocation, useNavigate } from 'react-router-dom';

export const useNavigateWithParams = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (path: string) => {
    const fullUrl = `${path}?${new URLSearchParams(location.search).toString()}`;
    navigate(fullUrl);
  };
};
